import axios from 'axios';

import { IStampsOfferLocation } from '@/shared/model/stamps-offer-location.model';

const baseApiUrl = 'api/stamps-offer-locations';

export default class StampsOfferLocationService {
  public find(id: number): Promise<IStampsOfferLocation> {
    return new Promise<IStampsOfferLocation>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IStampsOfferLocation): Promise<IStampsOfferLocation> {
    return new Promise<IStampsOfferLocation>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IStampsOfferLocation): Promise<IStampsOfferLocation> {
    return new Promise<IStampsOfferLocation>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
